import React from 'react';
import PropTypes from 'prop-types';

export default function Line(props) {
  return (
    <svg width={props.width} height={props.width} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.3333 16.7072L12 7.60156L2.66675 16.7072"
        stroke={props.color}
        strokeWidth={2}
      />
      <path 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6666 7.60161L11.9999 5L9.33325 7.60161L11.9999 10.2032L14.6666 7.60161ZM23.9998 16.7074L21.3332 14.1058L18.6665 16.7074L21.3332 19.3091L23.9998 16.7074ZM2.66665 14.1058L5.33331 16.7074L2.66665 19.3091L0 16.7074L2.66665 14.1058Z"
        fill={props.color}
      />
    </svg>
  );
}

Line.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Line.defaultProps = {
  color: '#202020',
  width: 24,
};